import styled from 'styled-components';

const Page = styled.div`
  max-height: 100vh;
  height: 100vh;
  overflow: auto;
  display: flex;
  flex: 1;
`;

export default Page;
